export function formatNumber(value?: number | string, decimals = 2, compact = false): string {
  const number = Number(value || 0)

  if (number !== 0 && number < 0.01 && decimals === 2) {
    return '<0.01'
  }

  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: decimals === 2 ? decimals : 0,
    maximumFractionDigits: decimals
  }

  if (compact) {
    options.notation = 'compact'
    options.compactDisplay = 'short'
  }

  return new Intl.NumberFormat(undefined, options).format(number)
}
